import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { fetchAdditionalAnalysis } from "../../../thunks/AnalysisStep";
import { AdditionalAnalysisStepResponse } from "../../../api/AnalysisStep";
import { CaseNote } from "../../../api/CaseNote";

export interface AdditionalAnalysisState {
    loadingStatus: 'idle' | 'pending' | 'succeeded' | 'failed';
    remarks?: CaseNote;
    error: string | null;
}

const initialState: AdditionalAnalysisState = {
    loadingStatus: 'idle',
    remarks: undefined,
    error: null,
};

const additionalAnalysisSlice = createSlice({
    name: 'additionalAnalysisData',
    initialState,
    reducers: {
        resetAdditionalAnalysis: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAdditionalAnalysis.pending, (state) => {
                state.loadingStatus = 'pending';
                state.error = null;
            })
            .addCase(fetchAdditionalAnalysis.fulfilled, (state, action: PayloadAction<AdditionalAnalysisStepResponse>) => {
                state.loadingStatus = 'succeeded';
                state.remarks = action.payload.remarks;
                state.error = null;
            })
            .addCase(fetchAdditionalAnalysis.rejected, (state) => {
                state.loadingStatus = 'failed';
                state.error = 'Failed to fetch additional analysis';
            });
    }
});

export const { resetAdditionalAnalysis } = additionalAnalysisSlice.actions;
export const additionalAnalysisReducer = additionalAnalysisSlice.reducer;

export const selectAdditionalAnalysisLoadingStatus = (state: RootState) => state.additionalAnalysisData.loadingStatus;
export const selectAdditionalAnalysisRemarks = (state: RootState) => state.additionalAnalysisData.remarks;
export const selectAdditionalAnalysisError = (state: RootState) => state.additionalAnalysisData.error;
